const Product = ({
    isEligibleForLeadGuarantee = false,
    paymentValidDuration = '',
    price = '',
    type = -1,
} = {}) => ({
    isEligibleForLeadGuarantee: Boolean(isEligibleForLeadGuarantee),
    paymentValidDuration: String(paymentValidDuration),
    price: String(price),
    type: Number(type),
});

const PaidInclusion = ({
    activeProductType = null,
    canBeActivatedOnMobile = false,
    isAutoBillEnabled = false,
    isEnabled = false,
    isFlatFeeEnabled = false,
    isPaymentRequired = false,
    isPaymentValid = false,
    // deprecated
    paymentValidDuration = '',
    // deprecated
    price = '',
    products = [],
} = {}) => ({
    activeProductType: Number(activeProductType),
    canBeActivatedOnMobile: Boolean(canBeActivatedOnMobile),
    isAutoBillEnabled: Boolean(isAutoBillEnabled),
    isEnabled: Boolean(isEnabled),
    isFlatFeeEnabled: Boolean(isFlatFeeEnabled),
    isPaymentRequired: Boolean(isPaymentRequired),
    isPaymentValid: Boolean(isPaymentValid),
    paymentValidDuration: String(paymentValidDuration),
    price: String(price),
    products: products.map(product => Product(product)),
});

export default PaidInclusion;
